// Single source of truth for the tabs enabled in the Configuración drawer.
// Used by Settings.view.jsx and SettingsNavigation.js so both stay in sync.
// The channel profile editor tab lives in the Canales (/spaces) drawer — see
// utils/spacesTabs.js.

export const getEnabledSettingsTabs = (permissions) => {
  const perms = permissions || {};
  const tabs = [];

  if (perms.whatsappTemplate) tabs.push("whatsappTemplates");
  if (perms.readTags || perms.writeTags) tabs.push("tagsTab");
  if (perms.readRols || perms.writeRols) tabs.push("rolesTab");
  if (perms.readDataSheetConfiguration || perms.writeDataSheetConfiguration)
    tabs.push("dataSheetConfigurationTab");
  if (perms.readCompany || perms.writeCompany) {
    tabs.push("configTab");
    tabs.push("integrationsTab");
  }
  return tabs;
};

// Resolve which tab should be active: the requested tab when it is enabled,
// otherwise fall back to the first enabled tab. Keeps navigation state
// (e.g. location.state.openTab) from mounting a tab the user cannot access.
export const resolveActiveSettingsTab = (requestedTab, enabledTabs) => {
  const tabs = Array.isArray(enabledTabs) ? enabledTabs : [];
  return tabs.includes(requestedTab) ? requestedTab : tabs[0];
};
